<template>
  <v-row class="customer-detail custom-border-to">
    <v-col md="12" sm="12" class="pt-0">
      <div class="new-white-box-overview-main nav">
        <div class="col-md-12 pt-0 px-0">
          <v-skeleton-loader
            class="custom-skeleton"
            v-if="pageLoading"
            type="text@1"
          ></v-skeleton-loader>

          <table v-else class="width-100" style="margin-top: 20px">
            <tr>
              <td
                class="py-1 font-size-20 font-weight-500 text-capitalize"
                width="150"
              >
                Amount
              </td>
              <td class="py-1 font-size-18 text-capitalize">
                <template v-if="lead.amount && lead.amount > 0">
                  <v-chip
                    small
                    class="py-0"
                    color="green"
                    label
                    style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      max-width: 150px;
                    "
                  >
                    <span class="text-white">
                      <b>${{ " " + lead.amount }}</b>
                    </span>
                  </v-chip>
                </template>
                <template v-else>
                  <em class="text-muted">No Amount</em>
                </template>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";

export default {
  name: "contact-details",
  title: "Lead",
  mixins: [CommonMixin, FileManagerMixin],
  data() {
    return {
      imageLoading: false,
    };
  },
  props: {
    lead: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  computed: {
    leadActivated() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.lead) === false) {
        return _this.lead.activated;
      }
      return false;
    },
  },
};
</script>
